import * as React from 'react';
import UserEntry from '../user-entry/user-entry';

const User = () => {
  return (
    <div>
      <UserEntry />
    </div>
  );
};

export default User;



// WEBPACK FOOTER //
// ./src/features/user/user.tsx